/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import Table from "examples/Tables/Table";
import {
    DataGrid,
    GridColDef,
    GridValueGetterParams,
    GridValueSetterParams,
} from '@mui/x-data-grid';
import Box from '@mui/material/Box';

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import VuiSwitch from "components/VuiSwitch";

import React, { useEffect, useState, useCallback } from "react"

import { useHistory, useLocation } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getAPIToken, getGuilds, updateMembers, getMembersForGuild } from 'GaiaAPI'
import { getValueFromString } from 'Utils'

import { FaUsers } from "react-icons/fa6";
import { LuSwords } from "react-icons/lu";

function MembersEdit() {
    const history = useHistory();
    const location = useLocation();
    const [guild, setGuild] = useState([]);
    const [guildName, setGuildName] = useState([]);
    const [guildColour, setGuildColour] = useState([]);
    const [membersCount, setMembersCount] = useState([]);
    const [members, setMembers] = useState([]);
    const [columns, setColumns] = useState([]);
    const [power, setPower] = useState([]);
    const [powerInc, setPowerInc] = useState([]);
    const [powerIncColour, setPowerIncColour] = useState([]);

    const [user, setUser] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [saveMessage, setSaveMessage] = useState([]);
    const [saveMessageColor, setSaveMessageColor] = useState([]);

    const [powerCheck, setPowerCheck] = useState(true);
    const handlePowerCheck = () => { setPowerCheck(!powerCheck); setGridColumns(!powerCheck, seCheck, heroesCheck); }

    const [seCheck, setSeCheck] = useState(true);
    const handleSeCheck = () => { setSeCheck(!seCheck); setGridColumns(powerCheck, !seCheck, heroesCheck); }

    const [heroesCheck, setHeroesCheck] = useState(true);
    const handleHeroesCheck = () => { setHeroesCheck(!heroesCheck); setGridColumns(powerCheck, seCheck, !heroesCheck); }

    function getDifference(params) {
        return getPowerIncForMember(params.row.power, params.row.previousPower);
    }

    function setGridColumns(power, se, heroes) {
        let myCols = [];

        try {
            myCols.push({ field: 'name', headerName: 'Name', width: 130, editable: false });
            if (power === true) {
                myCols.push({ field: 'power', headerName: 'Power', type: 'number', width: 100, editable: true });
                myCols.push({ field: 'previousPower', headerName: 'Previous', type: 'number', width: 90, editable: false });
                myCols.push({
                    field: 'difference',
                    headerName: 'Difference',
                    width: 160,
                    editable: false,
                    valueGetter: getDifference,
                });
                myCols.push({ field: 'ccl', headerName: 'CCL', type: 'number', width: 100, editable: true });
            }
            if (se === true) {
                myCols.push({ field: 'seeasy', headerName: 'SE Easy', type: 'number', width: 100, editable: true });
                myCols.push({ field: 'sehard', headerName: 'SE Hard', type: 'number', width: 120, editable: true });
                myCols.push({ field: 'se', headerName: 'Final SE', type: 'number', width: 120, editable: true });
            }
            if (heroes === true) {
                myCols.push({ field: 'stier', headerName: 'S Tier', type: 'number', width: 60, editable: true });
                myCols.push({ field: 'atier', headerName: 'A Tier', type: 'number', width: 60, editable: true });
                myCols.push({ field: 'trans', headerName: 'Trans', type: 'number', width: 50, editable: true });
                myCols.push({ field: 'd6', headerName: 'D6', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'd5', headerName: 'D5', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'd4', headerName: 'D4', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'd3', headerName: 'D3', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'd2', headerName: 'D2', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'd1', headerName: 'D1', type: 'number', width: 30, editable: true });
                myCols.push({ field: 't5', headerName: 'T5', type: 'number', width: 30, editable: true });
                myCols.push({ field: 't4', headerName: 'T4', type: 'number', width: 30, editable: true });
                myCols.push({ field: 't3', headerName: 'T3', type: 'number', width: 30, editable: true });
                myCols.push({ field: 't2', headerName: 'T2', type: 'number', width: 30, editable: true });
                myCols.push({ field: 't1', headerName: 'T1', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'v4', headerName: 'v4', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'v3', headerName: 'v3', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'v2', headerName: 'v2', type: 'number', width: 30, editable: true });
                myCols.push({ field: 'v1', headerName: 'v1', type: 'number', width: 30, editable: true });
            }
        }
        catch (err) {
            alert(err);
        }

        setColumns(myCols);
    }

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        let member = members.find(item => item.id === updatedRow.id);
        if (member) {
            member.power = updatedRow.power;
            member.ccl = updatedRow.ccl;
            const parts = [updatedRow.se, updatedRow.sehard].filter(val => val !== null && val !== undefined && val > 0);
            member.se = parts.length > 0 ? parts.join('~') : null;
            //member.se = updatedRow.se !== null ? updatedRow.se + '~' + updatedRow.sehard : updatedRow.sehard; //updatedRow.se ;
            member.seeasy = updatedRow.seeasy;
            member.stier = updatedRow.stier;
            member.atier = updatedRow.atier;
            member.trans = updatedRow.trans;
            member.d6 = updatedRow.d6;
            member.d5 = updatedRow.d5;
            member.d4 = updatedRow.d4;
            member.d3 = updatedRow.d3;
            member.d2 = updatedRow.d2;
            member.d1 = updatedRow.d1;
            member.t5 = updatedRow.t5;
            member.t4 = updatedRow.t4;
            member.t3 = updatedRow.t3;
            member.t2 = updatedRow.t2;
            member.t1 = updatedRow.t1;
            member.v4 = updatedRow.v4;
            member.v3 = updatedRow.v3;
            member.v2 = updatedRow.v2;
            member.v1 = updatedRow.v1;
            member.changed = true;
            setSaveDisabled(false);
            setGuildPower(guild, members)
        }
        return updatedRow;
    };

    function setGuildPower(myGuild, members) {
        let totalpower = 0;
        try {

            for (let i2 = 0; i2 < members.length; i2++) {
                if (members[i2].power)
                    totalpower = totalpower + getValueFromString(members[i2].power);
            }

            totalpower = totalpower / 1000;
            let pwrInc = 0;
            if (myGuild.previousPower) {
                pwrInc = ((totalpower / myGuild.previousPower) - 1) * 100;
            }

            pwrInc.toFixed(2) > 0 ? setPowerIncColour("success") : pwrInc.toFixed(2) < 0 ? setPowerIncColour("error") : setPowerIncColour("white");
            setPower(convertStringToNumber(totalpower, 2));
            setPowerInc(convertStringToNumber(pwrInc, 2) + '%');
        }
        catch (err) {
            alert(err);
        }
    }

    function setGuildDetails(guilds, guildname) {
        setSaveDisabled(true);
        setGuildName(guildname);
        let myGuild = guilds.find(g => g.name === guildname);
        if (myGuild && myGuild.colour) {
            setGuildColour('#' + myGuild.colour);
        }

        setMembersCount(myGuild.members);

        setPower(myGuild.power);
        setPowerInc(myGuild.powerInc);
    }

    const handleSaveClick = () => {
        let updaterDiscord = user.username + ' (' + user.name + ') - Web';
        setSaveMessage('');
        getAPIToken()
            .then((token) => {
                try {
                    updateMembers(token, members.filter(m => m.changed), updaterDiscord)
                        .then(() => {
                            setSaveMessage('Save Complete');
                            setSaveMessageColor("success");
                            setSaveDisabled(true);
                            localStorage.removeItem("guildsUpdateDate");
                        },
                            (err) => {
                                setSaveMessage(err.response.data.errors);
                                setSaveMessageColor("error");
                            });
                } catch (err) {
                    setSaveMessage(err.toString());
                    setSaveMessageColor("error");
                }
            },
                (err) => {
                    setSaveMessage(err.toString());
                    setSaveMessageColor("error");
                });
    };

    function convertStringToNumber(value, dp) {
        if (value) {
            var number = parseFloat(value.toString().replaceAll(",", ""));

            let decimalPlaces = 2;
            if (dp)
                decimalPlaces = dp;

            if (number >= 1000 || number <= -1000)
                return number.toLocaleString();
            else
                return number.toFixed(decimalPlaces);
        }
        else
            return value;
    };

    function getPowerIncForMember(power, previousPower) {
        let result = '';

        if (previousPower && power) {
            let powerDiff = power - previousPower;
            let powerPercent = ((power / previousPower) - 1) * 100;

            result = convertStringToNumber(powerDiff, 1) + ' (' + convertStringToNumber(powerPercent, 1) + '%)';

            if (powerDiff > 0)
                result = '+' + result;
        }

        return result;
    }

    const getDetails = useCallback(async () => {
        let guildname = location.state.guildname;
        setGuildName(guildname)
        setGridColumns(true, true, true);
        setPowerCheck(true);
        setSeCheck(true);
        setHeroesCheck(true);

        getUser()
            .then((result) => {
                setUser(result);
                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuildDetails(guildsResult, guildname);

                                getMembersForGuild(token, guildname)
                                    .then((membersResult) => {

                                        let myGuild = guildsResult.find(g => g.name === guildname);
                                        setGuild(myGuild);
                                        setGuildPower(myGuild, membersResult);

                                        for (let i2 = 0; i2 < membersResult.length; i2++) {
                                            membersResult[i2].id = i2;
                                            membersResult[i2].changed = false;
                                            membersResult[i2].power = getValueFromString(membersResult[i2].power);
                                            membersResult[i2].previousPower = getValueFromString(membersResult[i2].previousPower);
                                            membersResult[i2].ccl = getValueFromString(membersResult[i2].ccl);
                                            
                                            let arr = membersResult[i2].se.split('~');
                                            
                                            if (arr.length > 0) membersResult[i2].se = getValueFromString(arr[0]);
                                            if (arr.length > 1) membersResult[i2].sehard = getValueFromString(arr[1]);
                                        }
                                        setMembers(membersResult);
                                    },
                                    (error) => {
                                        alert(error);
                                    });
                            },
                            (error) => {
                                alert(error);
                            });
                    },
                    (error) => {
                        alert(error);
                    });
            },
            (error) => {
                history.push('/authentication/sign-in');
            });
    }, []);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} xl={3}>
                            <Card sx={{ padding: "17px" }} style={{ backgroundColor: guildColour }}>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                    <VuiTypography variant="lg" color="white">
                                        {guildName}
                                    </VuiTypography>
                                </VuiBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "Members", fontWeight: "regular" }}
                                count={membersCount}
                                percentage={{ color: membersCount < 30 ? "error" : "success", text: "/ 30" }}
                                icon={{ color: "info", component: <FaUsers size="20px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "Power" }}
                                count={power}
                                percentage={{ color: powerIncColour, text: powerInc }}
                                icon={{ color: "info", component: <LuSwords size="22px" color="white" /> }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} xl={3}>
                            <Card>
                                <VuiBox display="block" justifyContent="space-between" alignItems="center">
                                    <VuiButton
                                        disabled={saveDisabled}
                                        onClick={handleSaveClick}
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        Save Changes
                                    </VuiButton>
                                </VuiBox>
                                <VuiBox>
                                    <VuiTypography align="center" component="label" variant="button" color={saveMessageColor} fontWeight="medium">
                                        {saveMessage}
                                    </VuiTypography>
                                </VuiBox>
                            </Card>
                        </Grid>
                    </Grid>
                </VuiBox>

                <VuiBox mb={3}>
                    <Card>
                        <VuiBox display="flex" alignItems="center">
                            <Grid container spacing="18px">
                                <Grid item xs={12} lg={6} xl={1}>
                                    <VuiSwitch color="info" checked={powerCheck} onChange={handlePowerCheck} />
                                    <VuiTypography
                                        variant="caption"
                                        color="white"
                                        fontWeight="medium"
                                        onClick={handlePowerCheck}
                                        sx={{ cursor: "pointer", userSelect: "none" }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;Power
                                        </VuiTypography>
                                </Grid>
                                <Grid item xs={12} lg={6} xl={1}>
                                    <VuiSwitch color="info" checked={seCheck} onChange={handleSeCheck} />
                                    <VuiTypography
                                        variant="caption"
                                        color="white"
                                        fontWeight="medium"
                                        onClick={handleSeCheck}
                                        sx={{ cursor: "pointer", userSelect: "none" }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;SE
                                    </VuiTypography>
                                </Grid>
                                <Grid item xs={12} lg={6} xl={1}>
                                    <VuiSwitch color="info" checked={heroesCheck} onChange={handleHeroesCheck} />
                                    <VuiTypography
                                        variant="caption"
                                        color="white"
                                        fontWeight="medium"
                                        onClick={handleHeroesCheck}
                                        sx={{ cursor: "pointer", userSelect: "none" }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;Heroes
                                    </VuiTypography>
                                </Grid>
                            </Grid>
                        </VuiBox>
                        <Box
                            color='black'
                            sx={{
                                width: '100%',
                                '& .MuiDataGrid-cell': {
                                    color: '#C0C0C0',
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#FFFFFF',
                                },
                                '& .edit': {
                                    color: '#FFFFFF',
                                    background: '#004A7F'
                                },
                                '& .cold': {
                                    color: '#FF0000',
                                },
                                '& .hot': {
                                    
                                    color: 'rgba(157, 255, 118, 0.49)',
                                },
                                '& .none': {
                                    color: '#C0C0C0',
                                },
                            }}
                        >
                            <DataGrid rows={members} columns={columns} rowHeight={30} checkboxSelection={true}

                                initialState={{
                                    pagination: { paginationModel: { pageSize: 35 } },
                                }}

                                processRowUpdate={processRowUpdate}

                                getCellClassName={(params) => {
                                    if (params.field === 'power' || params.field === 'ccl' || params.field === 'se' || params.field === 'seeasy') {
                                        return 'edit';
                                    }
                                    if (params.field !== 'difference' || params.value == null) {
                                        return '';
                                    }
                                    return params.value.startsWith('+') ? 'hot' : params.value.startsWith('-') ? 'cold' : 'none';
                                }}
                                sx={{
                                boxShadow: 0,
                                border: 0
                                }} />
                        </Box>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default MembersEdit;
